import {
  Appointment,
  BasicDoctorInfoWithClinics,
  GTreatmentService,
  SUBJECT_KEYS,
} from "@elixir/types";
import getB from "./EkaBridge";
import { dispatch } from "./events/dispatch";
import {
  ADD_NEW_PT_APPT,
  BILLING_POPUP,
  CREATE_ABHA,
  EXPORT_ALL_PT,
  INIT_MEDICAL_CERTIFICATE,
  ON_ADD_ADDRESS,
  ON_ADD_VACCINATION,
  ON_APPT_ACTION,
  ON_BILL_PATIENT,
  ON_BOOK_LAB_TEST,
  ON_CREATE_TEMPLATE,
  ON_ENTER_VITALS,
  ON_HFR_CREATED_SUCCESSFULLY,
  ON_HPR_CREATED_SUCCESSFULLY,
  ON_MR_UPLOAD,
  ON_OPEN_ADMIT_PATIENT_DRAWER,
  ON_OPEN_TREATMENT_PLAN,
  ON_ORDER_MEDICINE,
  ON_PATIENT_EDIT_ACTION,
  ON_REFER_PATIENT,
  ON_REQUEST_MEDICAL_RECORDS,
  ON_REQUEST_PAYMENT,
  ON_SHOW_SA,
  OPEN_GLOBAL_SEARCH,
  OPEN_URL_IN_IFRAME_DIALOG,
  SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG,
} from "./events/types";
import { DexieDbType } from "./types/dexie";
import {
  BusinessConfig,
  DoctorCalendarConfigs,
  DoctorProfile,
  MyProfileResponse,
  TBusinessUsersConfig,
  TDoctorEvitalsConfig,
} from "./types/doctorProfile";
import { Visit } from "./types/visit";
import {
  CreateAppointmentOnFirestoreArgs,
  CreateAppointmentResponse,
  SendCommunicationProps,
  UpdateAppointmentOnFirestoreArgs,
  UpdateAssessmentOnFirestoreArgs,
} from "./DummyBridge";
import { PatientDetailsWithMeta } from "./types/patient";
import { DocumentData, QuerySnapshot } from "firebase/firestore";
import {
  Actor,
  MAP_PERSONA_TO_ACTOR_PREFIX,
} from "../../controllers/appointments/appointment-activity";

export const getDoc = async (): Promise<DoctorProfile | undefined> => {
  return getB().getDoc();
};

export const isPrintLabelEnabled = async (): Promise<boolean> => {
  return getB().isPrintLabelEnabled();
};

export const printLabelForPatientWithId = async (
  ptLocalId: string
): Promise<void> => {
  return getB().printLabelForPatientWithId(ptLocalId);
};

export const navigate = (
  type: "push" | "replace",
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  params
): void => {
  return getB().navigate(type, params);
};

// type GenieSettings = {
//   openPrintPdfInNewTab: boolean;
//   sendWelcome: boolean;
//   dform: boolean;
//   padV2: boolean;
//   smartSuggestions: boolean;
//   autoFillFollowUp: boolean;
//   barcodeEnabled: boolean;
//   isOrderMedicine: boolean;
//   isBookLabTest: boolean;
// };

export const getPxPrintUrl = (pxId: string): string => {
  return getB().getRxPrintUrl(pxId);
};

/**
 * @deprecated
 */
export const onPrintPdfInNewTab = (pxId?: string): void => {
  if (!pxId) return;
  window.open(`${getPxPrintUrl(pxId)}`, "_blank", "default");
};

export const isCanOrderMedicine = async (): Promise<boolean> => {
  try {
    // const table = await getB().getData("misc");
    // if (!table || !table.get) {
    //   return false;
    // }

    // const data = await table.get("settings");
    // const doctorProfile = await getDoc();
    // return Boolean(
    //   doctorProfile?.profile?.professional?.onboarded_for?.includes("HXNG")
    // );
    return false;
  } catch (e) {
    console.error("Error in isCanOrderMedicine", e);
    return false;
  }
};

export const isCanBookLabTest = async (): Promise<boolean> => {
  try {
    // const table = await getB().getData("misc");
    // if (!table || !table.get) {
    //   return false;
    // }

    // const data = await table.get("settings");
    const doctorProfile = await getDoc();

    return Boolean(
      doctorProfile?.profile?.professional?.onboarded_for?.includes("HXNG") ||
        doctorProfile?.profile?.professional?.onboarded_for?.includes("HELB")
    );
  } catch (e) {
    console.error("Error in isCanBookLabTest", e);
    return false;
  }
};

export const getLocalVisitByIds = async (ids: string[]): Promise<Visit[]> => {
  return getB().getLocalVisitByIds(ids);
};

export const isGoogleReviewLinkSetup = async (docId: string) => {
  // eslint-disable-next-line no-unsafe-optional-chaining
  const { docs } = getB()?.getMe();
  const doctor = docs.find((item) => item.id === docId);

  return !!doctor?.professional?.googleReviewLink;
};

export const showGoogleReviewDialog = ({ docId }: { docId: string }): void => {
  dispatch({
    type: SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG,
    docid: docId,
  });
};

export const showAddNewPatientPopover = ({
  docId,
}: {
  docId?: string; // docId is optional
}): void => {
  dispatch({
    type: ADD_NEW_PT_APPT,
    docid: docId,
  });
};

export const exportPtAsExcel = (): void => {
  dispatch({
    type: EXPORT_ALL_PT,
  });
};

export const initMedicalCertificate = (ap: Appointment): void => {
  dispatch({
    type: INIT_MEDICAL_CERTIFICATE,
    ap,
  });
};

export const toggleIframeActionDialog = (url: string): void => {
  dispatch({
    type: OPEN_URL_IN_IFRAME_DIALOG,
    url,
  });
};

export const onPatientEditAction = (appointment: Appointment): void => {
  dispatch({
    type: ON_PATIENT_EDIT_ACTION,
    a: appointment,
  });
};

type AppointmentActionPayload = {
  a: Appointment;
  cId: string;
  isNotesMode?: boolean;
  dontAllowStartVisit?: boolean;
  openVideoCallWindow?: boolean;
};
export const onAppointmentAction = ({
  a,
  cId,
  isNotesMode,
  dontAllowStartVisit,
  openVideoCallWindow,
}: AppointmentActionPayload): void => {
  dispatch({
    type: ON_APPT_ACTION,
    a,
    cId,
    isNotesMode,
    dontAllowStartVisit,
    openVideoCallWindow,
  });
};

export const onRequestPaymentAction = (a: Appointment): void => {
  dispatch({
    type: ON_REQUEST_PAYMENT,
    a,
  });
};

export const onUploadMedicalRecordEvent = (
  patientOid: string,
  options?: { source?: "file" | "camera" }
): void => {
  dispatch({
    type: ON_MR_UPLOAD,
    ptOid: patientOid,
    source: options?.source || "file",
  });
};

export const onBillingPopupAction = (a: Appointment): void => {
  dispatch({
    type: BILLING_POPUP,
    data: {
      aid: a.aid,
      patient: a.patient,
      uhid:
        a.formData?.find((fd) => fd.key === "uhid")?.value?.toString() || null,
      clinicId: a.clinic_id,
      source: "apt-queue",
    },
  });
};

export const onViewReceiptsPopupAction = (a: Appointment): void => {
  dispatch({
    type: BILLING_POPUP,
    data: {
      aid: a.aid,
      patient: a.patient,
      uhid:
        a.formData?.find((fd) => fd.key === "uhid")?.value?.toString() || null,
      clinicId: a.clinic_id,
      source: "apt-queue-view-receipts",
    },
  });
};

export const onRequestMedicalRecordsAction = (a: Appointment): void => {
  dispatch({
    type: ON_REQUEST_MEDICAL_RECORDS,
    a,
  });
};

export const onAddAddressAction = (a: Appointment): void => {
  dispatch({
    type: ON_ADD_ADDRESS,
    a,
  });
};

export const onBillPatientAction = (a: Appointment): void => {
  dispatch({
    type: ON_BILL_PATIENT,
    a,
  });
};

export const onReferAdocAction = (a: Appointment): void => {
  dispatch({
    type: ON_REFER_PATIENT,
    a,
  });
};

export const onAddVitalsAction = (a: Appointment): void => {
  dispatch({
    type: ON_ENTER_VITALS,
    a,
  });
};

export const onAddVaccination = (a: Appointment): void => {
  dispatch({
    type: ON_ADD_VACCINATION,
    a,
  });
};

export const onOrderMedicineAction = (a: Appointment): void => {
  dispatch({
    type: ON_ORDER_MEDICINE,
    a,
  });
};

export const onBookLabTestAction = (a: Appointment): void => {
  dispatch({
    type: ON_BOOK_LAB_TEST,
    a,
  });
};

type TOnlyApt = { a: Appointment; sa_id?: never; sa_ids?: never };
type TOnlySaId = { a?: never; sa_id: string; sa_ids?: never };
type TOnlySaIds = { a?: never; sa_id?: never; sa_ids: Array<string> };

export const onShowSAAction = ({
  a,
  sa_id,
  sa_ids,
}: TOnlyApt | TOnlySaId | TOnlySaIds): void => {
  dispatch({
    type: ON_SHOW_SA,
    a,
    sa_id,
    sa_ids,
  });
};

export const onCreateTemplateAction = (a: Appointment): void => {
  dispatch({
    type: ON_CREATE_TEMPLATE,
    a,
  });
};

export const openUniversalPatientSearch = (): void => {
  dispatch({
    type: OPEN_GLOBAL_SEARCH,
  });
};

export const onHprCreatedSuccessfully = () => {
  dispatch({
    type: ON_HPR_CREATED_SUCCESSFULLY,
  });
};

export const onHfrCreatedSuccessfully = () => {
  dispatch({
    type: ON_HFR_CREATED_SUCCESSFULLY,
  });
};

export const openCreateAbhaFlow = (a: Appointment) => {
  dispatch({
    type: CREATE_ABHA,
    a,
  });
};

export function getIdb(): DexieDbType {
  const { user } = getMe() || {};
  return getB()?.getIdb?.(user?.oid);
}

const defaultCalendarConfigsValue = { slotsFromDoctorCalendar: false };

const defaultEvitalsConfigValue = { manualPushOrder: false };

export const getCalendarConfigs = async (): Promise<DoctorCalendarConfigs> => {
  try {
    const table = getIdb().table("misc");
    if (!table) {
      return defaultCalendarConfigsValue;
    }

    const calendarConfigsItem = await table.get("calendarConfigs");
    const { calendarConfigs } = calendarConfigsItem || {
      calendarConfigs: defaultCalendarConfigsValue,
    };

    return calendarConfigs;
  } catch (e) {
    console.error("Error in getCalendarConfigs", e);
    return defaultCalendarConfigsValue;
  }
};

const defaultBusinessConfigsValue = {
  parkVisitEnabled: false,
  disableOnboardFlow: false,
};
export const getBusinessConfigs = async (): Promise<BusinessConfig> => {
  try {
    const table = getIdb().table("misc");
    if (!table) {
      return defaultBusinessConfigsValue;
    }

    const businessConfigsItem = await table.get("bizSettings");
    const { bizSettings } = businessConfigsItem || {
      bizSettings: defaultBusinessConfigsValue,
    };

    return bizSettings;
  } catch (e) {
    console.error("Error in getBusinessConfigs", e);
    return defaultBusinessConfigsValue;
  }
};

export const getEvitalsConfig = async (): Promise<TDoctorEvitalsConfig> => {
  try {
    const table = getIdb().table("misc");
    if (!table) {
      return defaultEvitalsConfigValue;
    }

    const evitalsGenieConfig = await table.get("evitalsConfig");
    const { evitalsConfig } = evitalsGenieConfig || {
      evitalsConfig: defaultEvitalsConfigValue,
    };

    return evitalsConfig;
  } catch (e) {
    console.error("Error in getEvitalsConfig", e);
    return defaultEvitalsConfigValue;
  }
};

export type CreateApptConfigItem = {
  id: string;
  name: string;
  isShown: boolean;
  icon?: string;
};

export const MUTUALLY_EXCLUSIVE_CONFIG_IDS = [
  "auto_create_receipt_on_services",
  "associate_payments_to_appointments",
] as const;

const defaultCreateApptConfig: CreateApptConfigItem[] = [
  {
    id: "treatmentPackage",
    name: "Treatment Package",
    isShown: true,
  },
  {
    id: "abha",
    name: "ABHA",
    isShown: true,
  },
  {
    id: "medicalHistory",
    name: "Medical History",
    isShown: true,
  },
  {
    id: "service",
    name: "Service",
    isShown: true,
  },
  {
    id: "auto_create_receipt_on_services",
    name: "Create Quick Receipt",
    isShown: true,
  },
  {
    id: "associate_payments_to_appointments",
    name: "Payment Status",
    isShown: false,
    icon: "circle-info",
  },
  {
    id: "tags",
    name: "Tags",
    isShown: true,
  },
];

export const getCreateApptConfig = async (): Promise<
  CreateApptConfigItem[]
> => {
  try {
    const table = getIdb().table("misc");
    if (!table) {
      return defaultCreateApptConfig;
    }

    const createApptConfig = await table.get("createApptConfig");
    const { createApptConfig: createApptConfigData } = createApptConfig || {
      createApptConfig: defaultCreateApptConfig,
    };

    const storedIds = new Set(
      createApptConfigData.map((item: CreateApptConfigItem) => item.id)
    );
    const newItems = defaultCreateApptConfig.filter(
      (item) => !storedIds.has(item.id)
    );
    const mergedConfig =
      newItems.length > 0
        ? [...createApptConfigData, ...newItems]
        : createApptConfigData;

    return mergedConfig;
  } catch (e) {
    console.error("Error in getCreateApptConfig", e);
    return defaultCreateApptConfig;
  }
};

export const saveCreateApptConfig = async (
  config: CreateApptConfigItem[]
): Promise<void> => {
  try {
    const idb = getIdb();
    if (!idb) {
      console.error("IDB not available");
      return;
    }
    await idb.misc.put({
      key: "createApptConfig",
      createApptConfig: config,
    });
    const bridge = getB();
    if (bridge?.pushGenieToBE) {
      await bridge.pushGenieToBE(["createApptConfig"]);
    }
  } catch (e) {
    console.error("Error in saveCreateApptConfig", e);
  }
};

export const getBusinessConfig = async (): Promise<TBusinessUsersConfig> => {
  try {
    const table = getIdb().table("misc");
    if (!table) {
      return {};
    }

    const businessConfig = await table.get("businessConfig");
    return businessConfig;
  } catch (e) {
    console.error("Error in getBusinessConfig", e);
    return {};
  }
};

export const getTreatmentServices = async ({
  clinic_id,
}: {
  clinic_id: string;
}): Promise<GTreatmentService[]> => {
  try {
    const table = getIdb().table("gTreatmentServices");
    if (!table) {
      return [];
    }
    return table.where("clinic_id").equals(clinic_id).toArray();
  } catch (e) {
    console.error("Error in getTreatmentServices", e);
    return [];
  }
};

export interface MassagedProfile {
  doctors: BasicDoctorInfoWithClinics[];
  allDocs: BasicDoctorInfoWithClinics[];
  clinics: MyProfileResponse["clinics"];
  business: MyProfileResponse["business"];
  loginmeta: MyProfileResponse["loginmeta"];
  user: MyProfileResponse["user"];
  hasAccessToMultipleDoctors?: boolean;
  amIDoctor?: boolean;
  user_meta?: MyProfileResponse["user_meta"];
}

export function getMe() {
  const myProfile = getB()?.getMe();

  const massagedProfile: MassagedProfile = {
    allDocs:
      myProfile?.docs?.map((item) => ({
        name: `${item?.personal?.s || "Dr."} ${item?.personal?.name.f || ""} ${
          item?.personal?.name.l || ""
        }`.trim(),
        oid: item?.id,
        pic:
          item?.personal?.pic ||
          `https://a.eka.care/doctor-avatar/${item.id}` ||
          "https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png",
        username: item?.professional?.username,
        clinics: item?.professional?.clinics.map((item) => item._id),
        default_clinic: item?.professional?.default_clinic,
      })) || [],
    doctors:
      myProfile?.docs?.map((item) => ({
        name: `${item?.personal?.s || "Dr."} ${item?.personal?.name?.f || ""} ${
          item?.personal?.name?.l || ""
        }`.trim(),
        oid: item?.id,
        pic:
          item?.personal?.pic ||
          `https://a.eka.care/doctor-avatar/${item.id}` ||
          "https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png",
        username: item?.professional?.username,
        clinics: item?.professional?.clinics.map((item) => item._id),
        default_clinic: item?.professional?.default_clinic,
      })) || [],
    clinics: myProfile?.clinics,
    business: {
      ...myProfile?.business,
      id: myProfile?.business?.id || `b-${myProfile?.loginmeta?.docid}`,
    },
    loginmeta: myProfile?.loginmeta,
    user: myProfile?.user,
    amIDoctor: !!myProfile?.doctor,
    user_meta: myProfile?.user_meta,
  };

  return massagedProfile;
}

export const onOpenTreatmentPlan = (a: Appointment) => {
  dispatch({
    type: ON_OPEN_TREATMENT_PLAN,
    a,
  });
};

export const onOpenAdmitPatientDrawer = (a: Appointment) => {
  dispatch({
    type: ON_OPEN_ADMIT_PATIENT_DRAWER,
    a,
  });
};

export const isTreatmentPlanEnabled = () => {
  return getB().isTreatmentPlanEnabled();
};

export function isDoctorOnly() {
  return getB().amIDoctorOnly();
}

export function isAllowed(name: SUBJECT_KEYS) {
  const bridge = getB();
  const isAllowed = bridge.isAllowed(name);
  return isAllowed;
}

export function isAccessAvailable(name: SUBJECT_KEYS) {
  const bridge = getB();
  const isAccessAvailable = bridge.isAccessAvailable(name);
  return isAccessAvailable;
}

export function showAccessDeniedError() {
  const bridge = getB();
  bridge.showAccessDeniedError();
}

export function isIpdEnabled() {
  const bridge = getB();
  return bridge.isIpdEnabled();
}

export function showPurchaseEkaCreditsPopover() {
  const bridge = getB();
  return bridge.showPurchaseEkaCreditsPopover?.();
}

export function showNewSignInStrip() {
  const bridge = getB();
  return bridge.showNewSignInStrip?.();
}

export async function createAppointment(
  arg: CreateAppointmentOnFirestoreArgs
): CreateAppointmentResponse {
  return getB().appointments.create(arg);
}

export async function getLastVisit(
  patient_oids: string[]
): Promise<QuerySnapshot<DocumentData, DocumentData> | undefined> {
  return getB().appointments.getLastVisit({ patientOids: patient_oids });
}

export async function getUpcomingVisit(
  patient_oids: string[]
): Promise<QuerySnapshot<DocumentData, DocumentData> | undefined> {
  return getB().appointments.getUpcomingVisit({ patientOids: patient_oids });
}

export async function updateAppointment(arg: UpdateAppointmentOnFirestoreArgs) {
  return getB().appointments.update(arg);
}

export async function updateAssement(arg: UpdateAssessmentOnFirestoreArgs) {
  return getB().appointments.updateAssement(arg);
}

export async function sendAppointmentCommunication(
  arg: SendCommunicationProps
) {
  console.log("🚀 ~ file: methods.ts:502 ~ arg:", arg);

  return getB().appointments.sendCommunication(arg);
}

export async function cancelAppointmentReminders({ aid }: { aid: string }) {
  return getB().appointments.cancelAllReminders({ aid });
}

export async function getPatientDetails({
  patientOids,
}: {
  patientOids: string[];
}): Promise<PatientDetailsWithMeta[]> {
  const patients = (await getB().getPatientsByIds(patientOids)) || [];
  const linkedPatientMap = new Map<string, string[]>();
  const patientIdToCaptainId = new Map<string, string>();
  const allPatientIdList: string[] = [];

  for (let i = 0; i < patients?.length; i++) {
    const patient = patients[i];
    const patientId = patient.id || patient.localId;
    const links = [patientId, ...(patient.link || [])];

    linkedPatientMap.set(patientId, links);

    links.forEach((linkedId) => {
      if (linkedId) {
        patientIdToCaptainId.set(linkedId, patientId);
      }
    });

    allPatientIdList.push(...links);
  }

  const visits = await getB().getAllVisitsWithPatientIds(allPatientIdList);
  const captainPtIdVisitSummary = new Map<
    string,
    PatientDetailsWithMeta["visits_meta"]
  >();

  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i];
    const patientId = visit.patient.id || visit.patient.localId;
    const captainPatientId = patientIdToCaptainId.get(patientId)!;
    const prevVisitSummary = {
      visitCount: 0,
      ...captainPtIdVisitSummary.get(captainPatientId),
    };

    prevVisitSummary.visitCount++;

    const isVisitNewerThanPrevSummary =
      visit.createdAt &&
      (!prevVisitSummary.lastVisitDate ||
        visit.createdAt.getTime() >= prevVisitSummary.lastVisitDate.getTime());

    if (isVisitNewerThanPrevSummary) {
      prevVisitSummary.lastVisitDate = visit.createdAt;
    }

    captainPtIdVisitSummary.set(captainPatientId, prevVisitSummary);
  }

  return patients.map((patient) => ({
    patient: patient,
    visits_meta: {
      visitCount: 0,
      ...captainPtIdVisitSummary.get(patient.id || patient.localId),
    },
  }));
}

export function initFirebaseAuth() {
  return getB().firebase.initAuth();
}

export async function getAppointmentById(aid: string) {
  return getB().appointments.get(aid);
}

export function openCrispChat(
  trackingName: string,
  trackingObject: { [k: string]: string | undefined } = {},
  text: string
) {
  const bridge = getB();
  return bridge.openCrispChat?.(trackingName, trackingObject, text);
}

export const returnActorNamePerformingWithPersona = () => {
  const { user } = getMe();
  let createdByName = "";
  let actorPerformingEvent: Actor;
  if (user?.ps) {
    actorPerformingEvent = MAP_PERSONA_TO_ACTOR_PREFIX[user?.ps];
  } else {
    actorPerformingEvent = user["is-d-s"] ? Actor.STAFF : Actor.DOCTOR;
  }

  const fullName = [user?.fn, user?.ln].filter(Boolean).join(" ").toLowerCase();
  if (actorPerformingEvent === Actor.DOCTOR) {
    createdByName = `Dr. ${fullName}`;
  } else {
    createdByName = fullName;
  }
  return createdByName;
};
